/* LA REMISE A ZERO CSS DE TOUTE L'APPLICATION THE SCAN.
 *
 * Gardee par `src/parcours/__tests__/D1-remise-a-zero-css.test.js` : le filet
 * d'empreintes monte les ecrans SANS ce fichier et ne verrait pas sa
 * disparition.
 *
 * ⚠️ 23/09/2026 — PASSAGE DE JSS A EMOTION, comme sur THE LAB, et pour la meme
 * raison : ce fichier employait `makeStyles` de `@material-ui/styles`, que la
 * documentation MUI declare « not compatible with React.StrictMode or React
 * 18+, and it will not be updated ». `@emotion/react` est deja installe et
 * c'est le moteur de style de MUI v5 lui-meme.
 *
 * ⛔ LES REGLES NE CHANGENT PAS D'UN CARACTERE. Elles sont plus courtes que
 * celles de THE LAB (ni `fontFamily` sur `#root`, ni `[contenteditable]`), et
 * c'est voulu : on migre THE SCAN tel qu'il est, pas en l'alignant.
 */
import React from 'react'
import { Global } from '@emotion/react'

const reglesGlobales = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  html: {
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  body: {
    backgroundColor: '#f4f6f8',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  a: {
    textDecoration: 'none',
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
}

const GlobalStyles = () => <Global styles={reglesGlobales} />

export default GlobalStyles
